
import Vue from "vue";
import {IButton} from "@/models/dossier-configs/cashier";
import AppColorPicker from "@/components/ColorPicker.vue";
import {ProductService} from "@/services";
import {Product} from "@/models/base";
import AppProductSkuAutocomplete from "@/components/products/ProductSkuAutocompleteWithoutModal.vue";

export default Vue.extend({
	data(){
		return {
			product: new Product()
		};
	},
	props: {
		value: {
			type: Object as () => IButton,
			required: true
		}
	},
	methods: {
		async save(){
			if(this.value.Sku){
				let p = await ProductService.findBySku(this.value.Sku);
				if(p.ID){
					this.value.ProductID = p.ID;
				}else{
					await this.$wf.dialog(this.$ct("sku-not-found"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
					return false;
				}
			}

			this.$emit("save",this.value);
		},
		onInput(product: Product){
			this.value.Text = product.Name;
			this.value.ProductID = product.ID;
		},
		cancel(){
			this.$emit("cancel");
		},
		deleteButton(){
			this.$emit("delete");
		}
	},
	created(){
		this.product.ID = this.value.ProductID;
		this.product.Sku = this.value.Sku;
	},
	components: {
		AppColorPicker,
		AppProductSkuAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
